import styled from 'styled-components';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';

export const FirmarAcordoButton = styled(Button)`
  width: 100%;
  height: 60px;
  font-size: 18px;
`;
